import { fetchApi, fetchApiWithProgress } from './api';
import { API_ENDPOINTS } from '../config';

export const getShopImages = async (shopId) => {
  const data = await fetchApi(API_ENDPOINTS.shopImages(shopId), { method: 'GET' });
  
  // Handle array response format: [{ id, shopId, imageUrl, imageKey, createdAt, updatedAt }]
  if (Array.isArray(data)) {
    return data;
  }
  
  // Handle wrapped response
  if (data && Array.isArray(data.data)) {
    return data.data;
  }
  
  return [];
};

export const uploadShopImage = async (shopId, imageFile, type = 'banner', onUploadProgress) => {
  const formData = new FormData();
  formData.append('images', imageFile);
  if (type) {
    formData.append('type', type);
  }

  return fetchApiWithProgress(API_ENDPOINTS.uploadShopImage(shopId), {
    method: 'POST',
    body: formData,
    onUploadProgress,
  });
};

export const deleteShopImage = async (imageId, shopId = null, type = null) => {
  return fetchApi(API_ENDPOINTS.deleteShopImage(imageId), {
    method: 'DELETE',
  });
};
